/** One meeting as an .ics file (the row's "Calendar" button adds just this meeting). */
import type { MeetingSummary } from "../types";

const stamp = (d: Date) => d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
const esc = (s: string) => s.replace(/[\;,]/g, (c) => `\\${c}`).replace(/\n/g, "\\n");

export function downloadMeetingIcs(m: MeetingSummary) {
  const start = new Date(m.startsAt);
  const end = new Date(start.getTime() + 3 * 3600_000); // the Clerk publishes no end time
  const url = `${location.origin}/dashboard/meetings/${encodeURIComponent(m.id)}`;
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Chicago Politics//EN", "BEGIN:VEVENT",
    `UID:${m.id}@chicagopolitics.org`, `DTSTAMP:${stamp(new Date())}`, `DTSTART:${stamp(start)}`, `DTEND:${stamp(end)}`,
    `SUMMARY:${esc(m.body)}`, ...(m.location ? [`LOCATION:${esc(m.location)}`] : []), `URL:${url}`, `DESCRIPTION:${esc(url)}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
  a.download = `${m.body.replace(/[^\w ]+/g, "").trim()} ${m.startsAt.slice(0, 10)}.ics`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
